import { render } from "./CustomersIcon.vue?vue&type=template&id=3e3ee3b8"
import script from "./CustomersIcon.vue?vue&type=script&lang=js"
export * from "./CustomersIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__